import BaseException from "./BaseException";

export default class BusinessLogicException extends BaseException {}
